module.exports = __webpack_public_path__ + "static/media/green-border.64de5f4f.svg";